<div class="signup-container">
  <div class="signup-content">
    <div class="signup-form-container">
      <app-secondary-logo />

      <div class="form-container">
        <div class="form-header">
          <h3 class="heading-lg">
            <span>{{ 'signUpPage.formHeader' | translate }}</span>
            <img src="assets/icons/waving-hand.svg" alt="waving hand emoji" />
          </h3>
          <p class="default-text text">
            {{ 'signUpPage.formSubheader' | translate }}
          </p>
        </div>
        <app-sign-up-form />
      </div>
    </div>

    <div class="signup-banner">
      <div class="banner-content">
        <div class="title-banner">
          <img src="assets/icons/sparkles.svg" alt="sparkles emoji" />
        </div>
        <h2 class="title-banner">
          {{ 'signUpPage.banner.title' | translate }}
        </h2>
        <p class="text-banner">
          {{ 'signUpPage.banner.description' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
